import { AsYouType, isValidNumber, parseNumber } from 'libphonenumber-js'

export const phoneValidate = value => {
  return !!value && isValidNumber(clean(value))
}

const parseNumberSafe = value => {
  let phoneMask = value

  try {
    phoneMask = parseNumber(value)
  } catch (error) {
    console.error(error)
  }

  if (phoneMask && typeof phoneMask === 'string') {
    return phoneMask
  }

  return value
}

const isPossiblePhone = (input = '') => {
  if (input.length === 0) {
    return false
  }

  const firstCharacter = input.substring(0, 1)

  // First character is '+'
  if (firstCharacter === '+') {
    return true
  }

  // First character is number
  if (!isNaN(parseInt(firstCharacter))) {
    return true
  }

  return false
}

export const clean = value => {
  if (!value) {
    return value
  }
  // Replace all non characters that are not a number, '|' or '+'
  return value.replace(/([^0-9|+|/])/g, '')
}

export const parsePhoneNumber = value => {
  if (!value) {
    return undefined
  }

  let parsedPhoneNumber = clean(value)

  // Replace '00' at start with '+'
  if (parsedPhoneNumber.startsWith('00')) {
    parsedPhoneNumber = '+' + parsedPhoneNumber.substring(2)
  }

  // Replace '04' at start with '+324'
  if (parsedPhoneNumber.startsWith('04')) {
    parsedPhoneNumber = '+324' + parsedPhoneNumber.substring(2)
  }

  // Replace '+3204' at start with '+324'
  if (parsedPhoneNumber.startsWith('+3204')) {
    parsedPhoneNumber = '+324' + parsedPhoneNumber.substring(5)
  }

  // Replace '+3200' at start with '+32'
  if (parsedPhoneNumber.startsWith('+3200')) {
    parsedPhoneNumber = '+32' + parsedPhoneNumber.substring(5)
  }

  if (parsedPhoneNumber && parsedPhoneNumber.length > 1) {
    parsedPhoneNumber = parseNumberSafe(parsedPhoneNumber)
  }

  return new AsYouType().input(parsedPhoneNumber)
}

export { AsYouType, isValidNumber, parseNumber, isPossiblePhone }



// WEBPACK FOOTER //
// ./src/utils/phone.js